var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("gs1-alert", [
    _c("p", [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$t("title", {
              company:
                _vm.saveGet(
                  _vm.glnsVerifiedResponse,
                  null,
                  "gs1Licence",
                  "licenseeName"
                ) ||
                _vm.saveGet(
                  _vm.gtinsVerifiedResponse,
                  "",
                  "gs1Licence",
                  "licenseeName"
                ),
              epc: _vm.gs1Id || ""
            })
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticStyle: { "font-size": "16px", "margin-top": "5px" } }, [
      _vm._v("\n    " + _vm._s(_vm.$t("message")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("p", { staticStyle: { "font-size": "16px", "margin-top": "5px" } }, [
      _vm._v("\n    " + _vm._s(_vm.$t("please")) + "\n    "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.gs1-germany.de/service/kontakt/",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("contact_gs1")) + "\n    ")]
      ),
      _vm._v("\n    " + _vm._s(_vm.$t("further_support")) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dfb1969", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dfb1969","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts/Gs1AlertCompanyInactive.vue
// module id = null
// module chunks = 